import React, { useContext } from 'react';

import { UI } from './ui';
import { PropertyContext } from '../../../../../context/property-context';

import {
  useGetPropertyAgreements,
  useGetPropertyContainers,
} from '../../../../../api/property/property-containers';

export const ApiWrapper = ({
  jsx,
  autoState,
}: {
  jsx: $TSFixMe;
  autoState: $TSFixMe;
}) => {
  const { id: propertyId } = useContext(PropertyContext);
  const {
    data,
    isLoading,
    isError: containersError,
    refetch: refetchContainers,
  } = useGetPropertyContainers(propertyId, {
    includeActiveAgreement: true,
    includeNextCollectionDate: true,
    includeTicketTypes: true,
    limit: 100,
  });

  const {
    data: agreements,
    isLoading: agreementsLoading,
    isError: agreementsError,
    refetch: refetchAgreements,
  } = useGetPropertyAgreements(propertyId, {
    limit: 100,
  });

  const containers = data?.data || [];

  // Page-level error only when a fetch failed and there's nothing to show
  // (placeholderData keeps prior data visible during a refetch). Keying on
  // `containers.length` — not `!data?.data` — is what catches an agreements-only
  // failure when the container list legitimately came back empty: otherwise the
  // page renders a misleading "no data" state instead of the error + retry.
  // When containers ARE present we keep rendering them even if agreements failed
  // (that just drops the price summary) rather than blanking the whole page.
  const hasError =
    (containersError || agreementsError) && containers.length === 0;

  const onRetry = () => {
    if (containersError) refetchContainers();
    if (agreementsError) refetchAgreements();
  };

  return (
    <UI
      jsx={jsx}
      autoState={autoState}
      loading={isLoading}
      agreementsLoading={agreementsLoading}
      containers={containers}
      agreements={agreements?.data}
      hasError={hasError}
      onRetry={onRetry}
    />
  );
};
